
import React, {useEffect, useRef} from 'react';
import styles from './CustomWraps.module.scss';
import panelStyles from 'components/homePanels/Panels.module.scss';
import ScrollEvent from "utils/ScrollEvent";
import ExploreSectionDown from "components/exploreSectionDown/ExploreSectionDown";
import MouseMove from "utils/MouseMove";
import PanelAnimations from "utils/PanelAnimations";
import ImageWrapper from "components/imageWrapper/ImageWrapper";
import BackGround from "components/homePanels/f-i_macroPage/heroLayers/BackGround";
import ProductCarousel from "components/homePanels/l_customWraps/productCarousel/ProductCarousel";
import DesignModal from "components/homePanels/l_customWraps/designModal/DesignModal";
import DesignsGallery from "components/homePanels/l_customWraps/designsGallery/DesignsGallery";
import ProductModal from "components/homePanels/l_customWraps/productModal/ProductModal";
import CreatorSlider from "components/homePanels/l_customWraps/creatorSlider/CreatorSlider";
import SelectionVisualizer from "components/homePanels/l_customWraps/selectionVisualizer/SelectionVisualizer";
import { TimelineMax, TweenMax} from "gsap";
import Tilt from "utils/Tilt";
import {useSelector} from "react-redux";
import HeaderLogo from "components/headerLogo/HeaderLogo";
import mainStyles from "components/homeParallax/HomeParallax.module.scss";
import {isMobileDevice} from "utils/Device";
import {buttonClick} from "utils/Helpers";

const CustomWraps = (props) => {

    const accessible = useSelector(state => state.accessible);
    const windowData = useSelector(state => state.window);
    const initialized = useRef(false);
    const product1 = useRef();
    const product2 = useRef();
    const product3 = useRef();

    const hero = useRef();
    const foreGround = useRef();
    const backGround = useRef();
    const fixedStage = useRef();
    const content = useRef();

    const prodTitle = useRef();
    const designTitle = useRef();

    const bgSet = {
        400: `https://msobd-storage.azureedge.net/images/bg-tool-400.jpg`,
        800: `https://msobd-storage.azureedge.net/images/bg-tool-800.jpg`,
        1350: `https://msobd-storage.azureedge.net/images/bg-tool-1350.jpg`,
        default: `https://msobd-storage.azureedge.net/images/bg-tool.jpg`
    }

    useEffect(()=>{
        fixedStage.current.scrollTop = 0;
    },[accessible.exploring])

    /** firefox remembers scroll position, reset on the way out the door **/
    window.addEventListener('beforeunload', ()=>{
        fixedStage.current.scrollTop = 0
    })

    /** on load screen reader focus on main image **/
    useEffect(()=>{
        setTimeout(()=>{
            if(props.status === 'active' && accessible.siteEntered) {
                product1.current.focus();
            }
        }, 1000)

    }, [props.status, accessible.siteEntered])

    useEffect(()=>{
        if(props.status === 'active' && accessible.siteEntered && !initialized.current) {

            initialized.current = true;

            setTimeout(()=>{

                let timeline = new TimelineMax({repeat: -1, repeatDelay: 5, delay: 0});
                timeline.fromTo(product1.current, {opacity: 0, transform: `perspective(100px) translateZ(-40px) translateX(40vw)`},
                    {opacity: 1, transform: `perspective(100px) translateZ(0px) translateX(0)`, delay: 0, duration: 1, onComplete: ()=>{
                            TweenMax.fromTo(product1.current, {opacity: 1, transform: `perspective(100px) translateZ(0px) translateX(0)`},
                                {opacity: 0, transform: `perspective(100px) translateZ(-40px) translateX(-40vw)`, delay: 1, duration: 1})
                        }})

                let timeline2 = new TimelineMax({repeat: -1, repeatDelay: 5, delay: 2});
                timeline2.fromTo(product2.current, {opacity: 0, transform: `perspective(100px) translateZ(-40px) translateX(40vw)`},
                    {opacity: 1, transform: `perspective(100px) translateZ(0px) translateX(0)`, delay: 0, duration: 1, onComplete: ()=>{
                            TweenMax.fromTo(product2.current, {opacity: 1, transform: `perspective(100px) translateZ(0px) translateX(0)`},
                                {opacity: 0, transform: `perspective(100px) translateZ(-40px) translateX(-40vw)`, delay: 1, duration: 1})
                        }})

                let timeline3 = new TimelineMax({repeat: -1, repeatDelay: 5, delay: 4});
                timeline3.fromTo(product3.current, {opacity: 0, transform: `perspective(100px) translateZ(-40px) translateX(40vw)`},
                    {opacity: 1, transform: `perspective(100px) translateZ(0px) translateX(0)`, delay: 0, duration: 1, onComplete: ()=>{
                            TweenMax.fromTo(product3.current, {opacity: 1, transform: `perspective(100px) translateZ(0px) translateX(0)`},
                                {opacity: 0, transform: `perspective(100px) translateZ(-40px) translateX(-40vw)`, delay: 1, duration: 1})
                        }})

            }, 1000)

        }

    }, [props, accessible.exploring, accessible.siteEntered])

    function nextCheck(){

        /** if hero panel is scrolled back to **/
        if(accessible.exploring && hero.current && (hero.current.getBoundingClientRect().top - hero.current.offsetParent.getBoundingClientRect().top) > -50){
            props.onEnd(props.macro.toLowerCase());
        }

    }

    function getContent(){

        if(accessible.exploring && props.status === 'active'){

            let bgKey = 'default';
            let set = {...bgSet}
            let sizeFound = false;
            delete set['default'];

            for (let [key] of Object.entries(set)) {
                if(!sizeFound && windowData.width < parseInt(key)) {
                    sizeFound = true;
                    bgKey = key;
                }
            }

            let h = fixedStage.current.getBoundingClientRect().height;

            let bgBaseline = ((h *1.25)-h) / 2;
            let top = isMobileDevice() ? `-${bgBaseline - 6 + 30}px` : 'top'

            let bgStyle = null;
            if(bgSet[bgKey]){
                bgStyle = {
                    backgroundImage: `url(${bgSet[bgKey]})`,
                    backgroundPosition: `center ${top}`,
                    marginTop: bgBaseline - 6  + 'px',
                }
            }

            return (
                <>

                    <div ref={content}/>

                    <div aria-hidden={accessible.modalOpen} className={styles.sectionBg} style={bgStyle}>
                        <ProductCarousel titleFocus={prodTitle}/>
                        <DesignsGallery titleFocus={designTitle}/>
                        <CreatorSlider />
                        <SelectionVisualizer scrollNode={fixedStage}/>
                    </div>

                    <span aria-hidden={accessible.modalOpen} className={mainStyles.accessibleContent} tabIndex={accessible.siteEntered && !accessible.modalOpen  ? 0 : null} role={'button'} aria-label={'Navigate to previous section'} onKeyDown={buttonClick} onClick={props.prevPanel}/>

                    <ScrollEvent target={fixedStage.current} scroll={nextCheck} debounce={100} mobileCheck={true}/>
                </>
            )
        }
    }

    return (
        <>
            <div ref={fixedStage} data-status={props.status} className={`${panelStyles.fixedStage}  ${accessible.exploring ? panelStyles.panelLocked : ''}`} style={{zIndex: props.zIndex}}>

                {(accessible.exploring) && (
                    <HeaderLogo ariaHidden={accessible.modalOpen}  menuClick={()=>props.menuClick('introText')}/>
                )}

                <div aria-hidden={accessible.modalOpen} ref={hero} className={`${panelStyles.hero}  ${panelStyles.fullSize}`}>
                    <div ref={foreGround} className={panelStyles.foreGround}>
                        <div className={`${panelStyles.logo} ${styles.logo}`}>
                            <div tabIndex={-1} ref={product1} className={styles.animatedDevice}><ImageWrapper
                                set={{ default: "https://msobd-storage.azureedge.net/images/customWraps/animation/1.png" }}
                                alt="Microsoft Surface Custom Skinned Laptop"
                            /></div>
                            <div ref={product2} className={styles.animatedDevice}><ImageWrapper
                                set={{ default: "https://msobd-storage.azureedge.net/images/customWraps/animation/2.png" }}
                                alt="Microsoft Surface Custom Skinned Surface Pro"
                            /></div>
                            <div ref={product3} className={`${styles.animatedDevice} ${styles.duo}`}><ImageWrapper
                                set={{ default: "https://msobd-storage.azureedge.net/images/customWraps/animation/3.png" }}
                                alt="Microsoft Surface Custom Skinned Duo"
                            /></div>
                        </div>

                        <div className={`${panelStyles.info} ${styles.customWrapsInfo}`}>
                            <h3>Redesign your Surface</h3>
                            <ExploreSectionDown dark={true} status={props.status} content={content} cta={'Get started'}/>
                        </div>
                    </div>

                </div>

                <BackGround aria-hidden={true} ref={backGround} set={bgSet}/>

                {getContent()}

            </div>

            <DesignModal active={props.status === 'active' && accessible.exploring} refocus={prodTitle.current}/>
            <ProductModal active={props.status === 'active' && accessible.exploring} refocus={designTitle.current}/>

            <PanelAnimations fixedStage={fixedStage} backGround={backGround} foreGround={foreGround} panel={'customize-yours'}/>

            <MouseMove status={props.status} backGround={backGround}/>
            <Tilt backGround={backGround}/>
        </>
    )
};

export default CustomWraps
